function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { bool, func, node, shape, string } from 'prop-types';
import clsx from 'clsx';
import SovosDialog from '../sovos-dialog/index';
import SovosDialogActions from '../sovos-dialog-actions';
import SovosDialogContent from '../sovos-dialog-content';
import SovosDialogTitle from '../sovos-dialog-title';
import SovosButton from '../sovos-button';
import useMosaicTranslation from '../internals/i18n/useMosaicTranslation';
const SovosConfirmationDialog = _ref => {
  let {
    ActionButtonProps,
    CancelButtonProps: CancelButtonPropsProp,
    negative = false,
    className,
    title,
    content,
    ...dialogProps
  } = _ref;
  const {
    t
  } = useMosaicTranslation();
  const defaultCancelButtonProps = {
    children: t('cancel'),
    onClick: undefined
  };
  const CancelButtonProps = {
    ...defaultCancelButtonProps,
    ...CancelButtonPropsProp
  };
  const cancelButton = /*#__PURE__*/React.createElement(SovosButton, _extends({
    className: "sovosConfirmationDialog__cancelButton",
    "data-testid": "sovosConfirmationDialog__cancelButton",
    id: "cancel-button",
    key: "cancel",
    variant: negative ? undefined : 'text'
  }, CancelButtonProps));
  const actionButton = /*#__PURE__*/React.createElement(SovosButton, _extends({
    className: "sovosConfirmationDialog__actionButton",
    color: negative ? 'error' : 'primary',
    "data-testid": "sovosConfirmationDialog__actionButton",
    id: "action-button",
    key: "action",
    variant: negative ? 'text' : undefined
  }, ActionButtonProps));
  const buttons = negative ? [actionButton, cancelButton] : [cancelButton, actionButton];
  return /*#__PURE__*/React.createElement(SovosDialog, _extends({
    className: clsx('sovosConfirmationDialog', className)
  }, dialogProps, {
    width: "small"
  }), /*#__PURE__*/React.createElement(SovosDialogTitle, null, title), content !== null && content !== void 0 ? content : /*#__PURE__*/React.createElement(SovosDialogContent, null, content), /*#__PURE__*/React.createElement(SovosDialogActions, null, buttons));
};
SovosConfirmationDialog.propTypes = {
  /**
   * False if the confirmation dialog represents a "negative" action (like
   * delete), otherwise true. Negative dialogs have different default
   * action button colors.
   */
  negative: bool,
  /**
   * Action button properties
   */
  ActionButtonProps: shape({
    children: node.isRequired,
    onClick: func
  }).isRequired,
  /**
   * Cancel button properties
   */
  CancelButtonProps: shape({
    children: node,
    onClick: func
  }),
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * The title of the dialog
   */
  title: node.isRequired,
  /**
   * Additional content for the dialog
   */
  content: node
};
SovosConfirmationDialog.baseComponent = {
  name: 'SovosDialog'
};
export default SovosConfirmationDialog;